import React from 'react'
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  Flex,
  Button,
  Text,
} from '@chakra-ui/react'

import { TeamInterface } from '../../coaches/store/coaches.types'

export interface IGamerLoginPromptProps {
  isOpen: boolean
  logOut: () => void
  leaveTeam: () => void
  team: TeamInterface | undefined
}

const GamerLoginPrompt: React.FC<IGamerLoginPromptProps> = ({
  isOpen,
  logOut,
  leaveTeam,
  team,
}) => (
  <Modal
    onClose={() => {}}
    isOpen={isOpen}
    scrollBehavior="outside"
    size={'lg'}
    isCentered
  >
    <ModalOverlay />
    <ModalContent
      bgColor="#272727"
      color="white"
      border="none"
      borderRadius="4px"
    >
      <ModalHeader textAlign="center">Attention!</ModalHeader>
      <ModalBody textAlign="center">
        <Text mb={4}>
          Dashboard access is restricted to Directors and Coaches only.
        </Text>
        <Text>
          You&apos;re currently a member of team{' '}
          <Text as="span" fontWeight="bold" color="brand.50">
            {team?.name}
          </Text>{' '}
          as a Gamer. To access the team dashboard, you&apos;ll need to leave
          your current team first.
        </Text>
        <Flex justifyContent="center" my={4}>
          <Button color="white" colorScheme="brand" onClick={leaveTeam}>
            Leave Team
          </Button>
          <Button
            color="white"
            colorScheme="brand"
            onClick={logOut}
            ml={4}
            variant="outline"
          >
            Log Out
          </Button>
        </Flex>
      </ModalBody>
    </ModalContent>
  </Modal>
)
export default GamerLoginPrompt
